var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control"},[(_vm.isOptional)?_c('option',{attrs:{"disabled":"","selected":"","hidden":""}}):_c('option',{attrs:{"disabled":"","selected":"","hidden":""}},[_vm._v("Select one")]),_vm._l((_vm.dropdowns),function(item){return _c('option',{domProps:{"value":item}},[_vm._v(_vm._s(item))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }